export const aboutData = {
    title: "Who I am",
    description1: "My name's Adithya Ajith. I'm a web developer from Kerala, INDIA",
    description2: "I use my time exploring and studying new technologies",
    image: 2
}